import { ADD_USER, REMOVE_USER } from './actionTypes'

export function addUser (user) {
    return { type: ADD_USER, user }
}

export function removeUser () {
    return { type: REMOVE_USER }
}
